import { SOURCE_COMPONENT } from '@atlassian/twc-xflow-modal/constants';

export const toSourceComponent = (
	source: string | undefined,
): (typeof SOURCE_COMPONENT)[keyof typeof SOURCE_COMPONENT] =>
	Object.values(SOURCE_COMPONENT).find((component) => component === source) ??
	SOURCE_COMPONENT.TWC_MARKETING_EMAIL;
